<app-icon-button
    *ngIf="viewport.phone$ | async"
    [style.justify-self]="'flex-end'"
    [title]="addToOrRemoveFromCartTitle$ | async"
    [placeholder]="!(bill$ | async)?.satisfiesBillPage || !(servicesInfoLoaded$ | async)"
    (click)="toggleBillInCart()"
    [disabled]="!(bill$ | async)?.due || (bill$ | async)?.paymentBlocked"
    [spinner]="updatingCartState$ | async"
>
    {{ !(isBillInCart$ | async) ? "add_shopping_cart" : "remove_shopping_cart" }}
</app-icon-button>

<egov-responsive-toolbar
    [buttons]="[
        { regularButton: addToCartButton, menuItem: addToCartMenuItem, menuItemGroup: 'cart' },
        (displayPrintBillButton$ | async) !== false ? { regularButton: printButton, menuItem: printMenuItem, menuItemGroup: 'print' } : null,
        (autoDraftEnabled$ | async) !== false ? { regularButton: autoDraftButton, menuItem: autoDraftMenuItem, menuItemGroup: 'track' } : null,
        (subscriptionsEnabled$ | async) !== false ? { regularButton: subscribeButton, menuItem: subscribeMenuItem, menuItemGroup: 'track' } : null,
        (watchListsEnabled$ | async) !== false ? { regularButton: watchButton, menuItem: watchMenuItem, menuItemGroup: 'track' } : null
    ]"
    [onlyMenu]="viewport.phone$ | async"
    [menuButton]="menuButton"
    [menuButtonEnabled]="(bill$ | async) && (servicesInfoLoaded$ | async)"
    [style.flex-basis]="(viewport.phone$ | async) ? 0 : null"
>
    <ng-template #addToCartButton>
        <add-or-remove-from-cart-button
            [showPlaceholder]="!(bill$ | async)?.satisfiesBillPage || !(servicesInfoLoaded$ | async)"
            [showRemove]="isBillInCart$ | async"
            [updating]="updatingCartState$ | async"
            [egovTooltip]="(bill$ | async)?.paymentBlocked ? paymentBlockedTooltip : null"
            [title]="(bill$ | async)?.paymentBlocked ? '' : (addToOrRemoveFromCartTitle$ | async)"
            [disabled]="!(isItselfPayable$ | async)"
            (addToCart)="toggleBillInCart()"
            (removeFromCart)="toggleBillInCart()"
        >
        </add-or-remove-from-cart-button>
    </ng-template>

    <ng-template #addToCartMenuItem>
        <button class="add-to-cart" mat-menu-item [disabled]="!(bill$ | async)?.due" (click)="toggleBillInCartMenuItemClickHandler()">
            {{ !(isBillInCart$ | async) ? "Add to Cart" : "Remove from Cart" }}
            <app-warned *ngIf="billOrDepsDelegated$ | async"></app-warned>
        </button>
    </ng-template>

    <ng-template #paymentBlockedTooltip>
        <div style="min-width: 220px; max-width: 350px" [innerHTML]="(blockMessages$ | async)?.paymentForbidden | MarkdownToHtml"></div>
    </ng-template>

    <ng-template #printButton>
        <a
            *ngIf="(bill$ | async)?.satisfiesBillPage && (servicesInfoLoaded$ | async); else printButtonPlaceholder"
            class="print"
            [href]="(bill$ | async)!.printUrl"
            [class.disabled]="!(bill$ | async)!.printUrl"
            target="_blank"
        >
            <button mat-button [disabled]="!(bill$ | async)!.printUrl">
                <span class="label">Print Bill</span>
                <mat-icon class="right">print</mat-icon>
            </button>
        </a>
        <ng-template #printButtonPlaceholder>
            <button mat-button class="placeholder">
                <egov-text-ui-placeholder class="label">Print Bill</egov-text-ui-placeholder>
                <mat-icon class="right"><egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder></mat-icon>
            </button>
        </ng-template>
    </ng-template>

    <ng-template #printMenuItem>
        <a class="print" mat-menu-item [href]="(bill$ | async)?.printUrl" target="_blank" [disabled]="!(bill$ | async)?.printUrl">
            Print Bill
        </a>
    </ng-template>

    <ng-template #autoDraftButton>
        <button
            *ngIf="(bill$ | async)?.satisfiesBillPage && (servicesInfoLoaded$ | async); else autoDraftButtonPlaceholder"
            mat-button
            class="auto-draft"
            (click)="showAutoDraftDialog()"
        >
            <span class="label">Auto-Draft</span>
            <mat-icon class="right">event_available</mat-icon>
        </button>
        <ng-template #autoDraftButtonPlaceholder>
            <button mat-button class="placeholder">
                <egov-text-ui-placeholder class="label">Auto-Draft</egov-text-ui-placeholder>
                <mat-icon class="right"><egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder></mat-icon>
            </button>
        </ng-template>
    </ng-template>

    <ng-template #autoDraftMenuItem>
        <button class="auto-draft" mat-menu-item (click)="showAutoDraftDialog()"> Auto-Draft </button>
    </ng-template>

    <ng-template #subscribeButton>
        <button
            *ngIf="(bill$ | async)?.satisfiesBillPage && (servicesInfoLoaded$ | async); else subscribeButtonPlaceholder"
            mat-button
            class="subscriptions"
            (click)="showSubscriptionsDialog()"
        >
            <span class="label">Subscriptions</span>
            <mat-icon class="right">add_alert</mat-icon>
        </button>
        <ng-template #subscribeButtonPlaceholder>
            <button mat-button class="placeholder">
                <egov-text-ui-placeholder class="label">Subscriptions</egov-text-ui-placeholder>
                <mat-icon class="right"><egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder></mat-icon>
            </button>
        </ng-template>
    </ng-template>

    <ng-template #subscribeMenuItem>
        <button class="subscriptions" mat-menu-item (click)="showSubscriptionsDialog()"> Subscriptions </button>
    </ng-template>

    <ng-template #watchButton>
        <button
            *ngIf="(bill$ | async)?.satisfiesBillPage && (servicesInfoLoaded$ | async); else watchButtonPlaceholder"
            mat-button
            class="watch"
            title="Add or remove this parcel from watch lists"
            (click)="watchParcel()"
        >
            <span class="label">Watch</span>
            <mat-icon class="right">visibility</mat-icon>
        </button>
        <ng-template #watchButtonPlaceholder>
            <button mat-button class="placeholder">
                <egov-text-ui-placeholder class="label">Watch</egov-text-ui-placeholder>
                <mat-icon class="right"><egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder></mat-icon>
            </button>
        </ng-template>
    </ng-template>

    <ng-template #watchMenuItem>
        <button mat-menu-item class="watch" (click)="watchParcel()"> Watch </button>
    </ng-template>

    <ng-template #menuButton>
        <app-icon-button [placeholder]="!((bill$ | async)?.satisfiesBillPage && (servicesInfoLoaded$ | async))" title="More options" [moreIconAtTheEnd]="true">
            more_vert
        </app-icon-button>
    </ng-template>
</egov-responsive-toolbar>
